module.exports = __webpack_public_path__ + "img/stock5.fdfb4f15.png";